<template>
  <div v-show="article">

    <!-- Modal -->
    <div class="modal fade" id="editArticleModal" ref="editArticleModalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title mb-3">Edytuj artykuł</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>

            <div class="position-absolute mt-5" v-if="exchangeRates">
<span v-if="exchangeRates.rates">
    EUR:
    <b>{{ exchangeRates.rates.eur }}</b>

    USD:
    <b>{{ exchangeRates.rates.usd }}</b>

    ({{ exchangeRates.date }})
</span>
            </div>
          </div>
          <form @submit.prevent="submitUpdateArticle">
            <div class="modal-body">

              <div class="container">
                <div class="row">
                  <!-- Form Fields -->
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="catalog_number">Nr Katalogowy</label>
                      <input id="catalog_number" class="form-control form-control-sm" type="text"
                             v-model="form.catalog_number">
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="model">Model</label>
                      <input id="model" class="form-control form-control-sm" type="text" v-model="form.model">
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="unit_id">Jednostka</label>
                      <select id="unit_id" class="form-select form-select-sm" v-model="form.unit_id">
                        <option v-for="unit in units" :key="unit.id" :value="unit.id">{{ unit.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="description">Opis</label>
                      <textarea id="description" class="form-control form-control-sm"
                                v-model="form.description"></textarea>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="description">Szczegóły</label>
                      <textarea id="description" class="form-control form-control-sm"
                                v-model="form.details"></textarea>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="link">Link</label>
                      <input id="link" class="form-control form-control-sm" type="text" v-model="form.link">
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="producent">Producent</label>
                      <select id="producent" class="form-select form-select-sm" v-model="form.producer_id">
                        <option v-for="producer in producers" :key="producer.id" :value="producer.id">{{
                            producer.name
                          }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="category">Kategoria</label>
                      <select id="category" class="form-select form-select-sm" v-model="form.category_id">
                        <option v-for="category in categories" :key="category.id" :value="category.id">{{
                            category.name
                          }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="vat">VAT</label>
                      <input id="vat" class="form-control form-control-sm" type="number" v-model="form.vat">
                    </div>
                  </div>


                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="price_netto">Cena Netto</label>
						<input
							id="price_netto"
							class="form-control form-control-sm"
							type="number" min="0"  step="0.01"
							v-model.number="form.price_netto">
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="price_brutto">Cena Brutto</label>
                      <input id="price_brutto" class="form-control form-control-sm" type="number" 
                             :value="priceBrutto" disabled>
                    </div>
                  </div>

					<div class="col-md-3">
						<label class="form-label">Waluta</label>
 <select
        v-model.number="form.currency"
        class="form-select form-select-sm"
    >
        <option
            v-for="c in currencys"
            :key="c.id"
            :value="Number(c.id)"
        >
            {{ c.name }}
        </option>
    </select>
					</div>


                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="price_netto_zl">Cena Netto (PLN)</label>
                      <input id="price_netto_zl" class="form-control form-control-sm" type="number" 
                             :value="priceNettoZl" disabled>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="price_brutto_zl">Cena Brutto (PLN)</label>
                      <input id="price_brutto_zl" class="form-control form-control-sm" type="number"
                             :value="priceBruttoZl" disabled>
                    </div>
                  </div>
				  


                  <!-- Wartość netto (automatyczna) -->
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="value_net">Wartość Netto</label>
                      <input id="value_net" class="form-control form-control-sm" type="number" 
                             :value="valueNet" disabled>
                    </div>
                  </div>

                  <!-- Wartość brutto (automatyczna) -->
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="value_gross">Wartość Brutto</label>
                      <input id="value_gross" class="form-control form-control-sm" type="number" 
                             :value="valueGross" disabled>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="location">Lokalizacja</label>
                     <input id="location" class="form-control form-control-sm" type="text" v-model="form.location">
                     </div>
                  </div>
				  
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="value_gross">Dostawcy</label>
                      <input id="value_gross" class="form-control form-control-sm" type="text" v-model="form.suppliers">
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                <i class="bi bi-x-square me-2"></i>Zamknij
              </button>
              <button v-if="form.isDirty" type="submit" class="btn btn-primary">
                <i class="bi bi-save me-2"></i> zapisz
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Modal} from "bootstrap";
import {useForm} from "@inertiajs/vue3";
import {ref} from "vue";

export default {
  props: {
    article: Object,
    units: Object,
    categories: Object,
    producers: Object,
    warehouses: Object,
    exchangeRates: Object,
	currencys: { type: Array, default: () => [] },
  },

  data() {
    return {
      modalObj: null,
      form: useForm({
        id: this.article?.id || null,
        catalog_number: this.article?.catalog_number || '',
        model: this.article?.model || '',
        unit_id: this.article?.unit_id || null,
        description: this.article?.description || '',
        details: this.article?.details || '',
        link: this.article?.link || '',
        location: this.article?.location || '',
        producer_id: this.article?.producer_id || null,
        category_id: this.article?.category_id || null,
        vat: this.article?.vat || 0,
        price_netto: this.article?.price_netto || 0,
		price_brutto: this.article?.price_brutto || 0,
		price_netto_zl: this.article?.price_netto_zl || 0,
		price_brutto_zl: this.article?.price_brutto_zl || 0,
        income: this.article?.income || 0,
        outflow: this.article?.outflow || 0,
        suppliers: this.article?.suppliers || '',
		currency: Number(this.article?.currency?.id ?? 0),
      }),
    };
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.editArticleModalEle);
	  this.$refs.editArticleModalEle.addEventListener('hidden.bs.modal', () => {
    this.$emit('clear-selection');
  });
  },

  watch: {
article: {
    immediate: true,
    handler(newVal) {
        if (newVal) {
            Object.assign(this.form, {
                ...newVal,
                currency: Number(newVal.currency?.id ?? 0)
            });

            this.recalculatePrices();
        }
    }
},
'form.currency'() {
    this.recalculatePrices();
},
'form.vat'() {
    this.recalculatePrices();
},
'form.price_netto'() {
    this.recalculatePrices();
},
  },
computed: {
    selectedCurrencyName() {
        const currency = this.currencys.find(c => c.id == this.form.currency);
        return currency ? currency.name : '';
    },

    kurs() {
        return this.getRate(this.form.currency);
    },

    priceNetto() {
        return Number(this.form.price_netto).toFixed(2);
    },

    priceBrutto() {
        return (this.form.price_netto * (1 + this.form.vat / 100)).toFixed(2);
    },

priceNettoZl() {
    return (this.form.price_netto * this.kurs).toFixed(2);
},

priceBruttoZl() {
    return (
        this.form.price_netto *
        (1 + this.form.vat / 100) *
        this.kurs
    ).toFixed(2);
},

    valueNet() {
        return (this.form.price_netto * this.form.stock_quantity).toFixed(2);
    },

    valueGross() {
        return (this.priceBrutto * this.form.stock_quantity).toFixed(2);
    },
},

  methods: {
  recalculatePrices() {
    const rate = this.getRate(this.form.currency);

    this.form.price_brutto = this.calcBrutto(
        this.form.price_netto,
        this.form.vat
    );

    this.form.price_netto_zl =
        +(this.form.price_netto * rate).toFixed(2);

    this.form.price_brutto_zl =
        +(this.form.price_brutto * rate).toFixed(2);
},

    calcBrutto(netto, vat) {
    netto = parseFloat(netto) || 0
    vat = parseFloat(vat) || 0
    return +(netto * (1 + vat / 100)).toFixed(2)
  },
  
  getRate(currencyId) {
    const currency = this.currencys.find(c => c.id == currencyId);
    if (!currency) {
        return 1;
    }
    return parseFloat(
        this.exchangeRates?.rates?.[currency.name.toLowerCase()] ?? 1
    );
},
  
  
    submitUpdateArticle() {
      this.$inertia.post(
          route("articles.saveChanges"),
          {updated: [this.form]},
          {
            preserveState: true,
            onSuccess: () => {
              this.$emit("add-article", this.form);
              this.$emit("update-success", "Artykuł został zaktualizowany poprawnie.");
			  this.$emit('clear-selection');
              this.hide();
            },
            onError: (resp) => {
              console.log("Błąd podczas zapisywania danych:", Object.keys(resp)[0] ?? resp);
              this.$emit("update-error", Object.keys(resp)[0] ?? resp);
            },
          }
      );
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  },
};
</script>
